import React from 'react';
import { PropTypes } from 'prop-types';
import { styles } from './PrintFormStructure.styles';
import { useSelector } from 'react-redux';
import GroupItem from './GroupItem';
import NonField from './NonFields';

const GroupType = ({ field, entry }) => {
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    const isRtl = formStructure?.presentation?.rtl;
    const classes = styles({ isRtl });
    const fields =
        formStructure?.fields?.length &&
        [...formStructure?.fields]
            ?.sort((a, b) => a.order - b.order)
            ?.filter(
                (val) => val.data_type !== 'file' && !val?.presentation?.invisible && !val?.hidden
            );
    const childFields = fields?.filter(
        (val) =>
            (field.name && val.parent === field.name) ||
            (field.suggested_name && val.parent === field.suggested_name)
    );

    return (
        <div className={classes.row}>
            {childFields?.map((item) => (
                <>
                    {item.data_type === 'none' ? (
                        <NonField field={item} />
                    ) : (
                        <GroupItem key={`Group-${item.name}`} item={item} entry={entry} />
                    )}
                </>
            ))}
        </div>
    );
};
GroupType.propTypes = {
    fields: PropTypes.array,
    field: PropTypes.object,
    entry: PropTypes.object
};
export default GroupType;
